import { render } from "./SignUpRole.vue?vue&type=template&id=1d38b969&ts=true&lang=pug"
import script from "./SignUpRole.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpRole.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__